export const scrollToId = (id, { settle = false } = {}) => {
  const el = document.getElementById(id);
  if (!el) return;
  // Kompensér for den sticky headers aktuelle højde (banner + menu varierer pr. skærmbredde)
  const offset = () => -((document.querySelector('[data-testid="nav-sticky"]')?.offsetHeight) || 100) - 12;
  const go = (immediate = false) => {
    if (window.__lenis) {
      window.__lenis.scrollTo(el, immediate ? { offset: offset(), immediate: true } : { offset: offset(), duration: 1.4 });
    } else {
      const y = el.getBoundingClientRect().top + window.scrollY + offset();
      window.scrollTo({ top: y, behavior: immediate ? "auto" : "smooth" });
    }
  };
  go();
  // Billeder kan loade undervejs og skubbe layoutet — gen-scroll for at lande præcist
  setTimeout(go, 700);
  if (settle) {
    setTimeout(() => go(true), 1500);
    // Deferred sektioner højere oppe på forsiden kan først blive monteret,
    // når den første scroll passerer dem. En sen slutmåling holder dybe
    // QR-/hash-landinger som Brochure på deres rigtige anker.
    setTimeout(() => go(true), 3000);
  }
};
